import { Tooltip } from '@mui/material';
import { Scan } from '../../../../../services/entities/impl/blfApi/schemas/scan';
import { useRecentScanIndicator } from '../../hooks/useRecentScanIndicator';
import { useScanStatusIndicator } from '../../hooks/useScanStatusIndicator';
import { isRecentScan } from '../../utils/isRecentScan';

export const ScanStatusIndicator = ({ scan }: { scan: Scan }) => {
  const { pipelineStatus: status, scanDate } = scan;
  const {
    longDescription: recentTooltip,
    color: recentColor,
    icon: RecentIcon,
  } = useRecentScanIndicator();

  const {
    longDescription: statusTooltip,
    color: statusColor,
    icon: StatusIcon,
    isSupported: displayStatus,
  } = useScanStatusIndicator(status);

  let tooltip = statusTooltip,
    color = statusColor,
    Icon = StatusIcon;

  if (isRecentScan(scanDate) && !displayStatus) {
    tooltip = recentTooltip;
    color = recentColor;
    Icon = RecentIcon;
  } else if (!displayStatus) return null;

  return (
    <Tooltip title={tooltip}>
      <Icon sx={{ color: color.main, fontSize: '0.75rem' }} />
    </Tooltip>
  );
};
